import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { OpAttorneyAPIResponse, OpAttorneyModel } from '../models/opattorney.model';

@Injectable()
export class OpAttorneyService {
  private _attorneys$ = new BehaviorSubject<OpAttorneyModel[]>([]);

  constructor(private apiService: ApiService) {}

  get attorneys$(): Observable<OpAttorneyModel[]> {
    return this._attorneys$;
  }

  public fetchAll(casId: string) {
    this.apiService
      .get<OpAttorneyAPIResponse>('opattorney/get', { params: { casId: casId }, showToast: false })
      .subscribe((response) => {
        if (response?.attorneys) this._attorneys$.next(response.attorneys);
      });
  }
}
